import React, { useEffect, useState } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'dva';
import { Form, Input, Spin, Row, Col, Card, InputNumber } from 'antd';
import ButtonBar from '../../ButtonBar/ButtonBar';
import { ACTION_APP_ADD_NOTIFICATION, ACTION_APP_GO_TO_ROUTE } from '../../../models/app';
import { ACTION_HEADER_UPDATE } from '../../../models/header';
import { ROUTE_CLIENT_PACKAGES_LIST } from '../../../routes';
import styles from './../styles.less';
import {
  ACTION_CLIENT_PACKAGES_CREATE,
  ACTION_CLIENT_PACKAGES_LOAD_ITEM,
  ACTION_CLIENT_PACKAGES_UPDATE,
} from '../../../models/clientPackages';

const { Item } = Form;

const ClientPackagesItem = (props) => {
  const { loading, form, intl } = props;
  const clientPackageId = props.match.params.clientPackageId || null;
  const [clientPackage, setClientPackage] = useState(null);

  useEffect(() => {
    if (clientPackageId) {
      props
        .dispatch({
          type: ACTION_CLIENT_PACKAGES_LOAD_ITEM,
          payload: { id: clientPackageId },
        })
        .then((response) => {
          if (!response) {
            return;
          }

          setClientPackage({
            id: clientPackageId,
            title: response.title,
            monthly_limit: response.monthly_limit,
          });
        });
    }

    props.dispatch({
      type: ACTION_HEADER_UPDATE,
      payload: {
        title: clientPackageId
          ? 'Component.Administration.ClientPackages.Edit.Form.Title'
          : 'Component.Administration.ClientPackages.New.Form.Title',
      },
    });
  },
  []);

  const goToClientPackages = () => {
    props.dispatch({
      type: ACTION_APP_GO_TO_ROUTE,
      payload: { routeName: ROUTE_CLIENT_PACKAGES_LIST },
    });
  };

  const addNotification = (id) => {
    props.dispatch({
      type: ACTION_APP_ADD_NOTIFICATION,
      payload: {
        type: 'success',
        message: 'Common.Success',
        description: id
          ? 'Component.Administration.ClientPackages.Edit.Success.Text'
          : 'Component.Administration.ClientPackages.New.Success.Text',
      },
    });
  };

  const saveClientPackage = async (data) => {
    const id = clientPackage ? clientPackage.id : null;
    const success = await props.dispatch({
      type: id ? ACTION_CLIENT_PACKAGES_UPDATE : ACTION_CLIENT_PACKAGES_CREATE,
      payload: {
        id,
        data,
      },
    });

    if (success) {
      addNotification(id);
      goToClientPackages();
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    form.validateFieldsAndScroll(['title', 'monthly_limit'], (err, values) => {
      if (!err) {
        saveClientPackage({
          title: values.title,
          monthly_limit: values.monthly_limit,
        });
      }
    });
  };

  return (
    <Spin
      spinning={
        !!loading.effects[ACTION_CLIENT_PACKAGES_CREATE] ||
        !!loading.effects[ACTION_CLIENT_PACKAGES_UPDATE] ||
        !!loading.effects[ACTION_CLIENT_PACKAGES_LOAD_ITEM]
      }
    >
      <div className={styles.containerLarge}>
        <Form onSubmit={handleSubmit}>
          <Card>
            <Row gutter={32}>
              <Col span={12}>
                <Item
                  label={
                    <FormattedMessage id="Component.Administration.ClientPackages.Form.Title" />
                  }
                >
                  {form.getFieldDecorator('title', {
                    initialValue: clientPackage ? clientPackage.title : '',
                    rules: [
                      {
                        required: true,
                        min: 3,
                        max: 255,
                        message: intl.formatMessage({
                          id: 'Component.Administration.ClientPackages.Validation.Title',
                        }),
                      },
                    ],
                  })(<Input maxLength={255} type="text" />)}
                </Item>
              </Col>
              <Col span={12}>
                <Item
                  label={
                    <FormattedMessage id="Component.Administration.ClientPackages.Form.MonthlyLimit" />
                  }
                >
                  {form.getFieldDecorator('monthly_limit', {
                    initialValue: clientPackage ? clientPackage.monthly_limit : undefined,
                    rules: [
                      {
                        required: true,
                        type: 'integer',
                        min: 1,
                        message: intl.formatMessage({
                          id: 'Component.Administration.ClientPackages.Validation.MonthlyLimit',
                        }),
                      },
                    ],
                  })(
                    <InputNumber
                      min={1}
                      precision={0}
                      style={{ width: '100%' }}
                    />,
                  )}
                </Item>
              </Col>
            </Row>
          </Card>
          <ButtonBar cancelAction={goToClientPackages} />
        </Form>
      </div>
    </Spin>
  );
};

export default connect(({ app, loading }) => ({ app, loading }))(
  Form.create()(injectIntl(ClientPackagesItem)),
);



// WEBPACK FOOTER //
// ./src/components/ClientPackages/ClientPackagesItem/index.js